import React from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import { useTheme } from 'styled-components';

interface Props extends TextProps {
    children: string | string[];
}

/**
 * Header 3 text component (h3)
 */
const H3Text = ({ style, children, ...props }: Props): JSX.Element => {
    const styles = useStyles();

    // render
    return (
        <Text style={[styles.text, style]} {...props}>
            {children}
        </Text>
    );
}

const useStyles = () => {
    const { fontSizes, fonts, colors } = useTheme();

    return StyleSheet.create({

        text: {

            fontSize: fontSizes.h3,
            fontFamily: fonts.compact.medium,
            color: colors.text.light,
        }
    });
}

export default H3Text;
